document.addEventListener("DOMContentLoaded", () => {
  const filterWrapper = document.querySelector(".el-collection-filter");
  if (!filterWrapper) return;

  const productCards = document.querySelectorAll(".el-product-card");
  const activeFilters = {};

  // Price inputs and sliders
  const minInput = filterWrapper.querySelector(".el-price-min");
  const maxInput = filterWrapper.querySelector(".el-price-max");
  const minSlider = filterWrapper.querySelector(".el-price-slider.min");
  const maxSlider = filterWrapper.querySelector(".el-price-slider.max");
  const priceValueDisplay = filterWrapper.querySelector(".el-price-value");

  function updatePriceFilters() {
    const min = parseFloat(minInput.value) || 0;
    const max = parseFloat(maxInput.value) || parseFloat(maxSlider.max);

    minSlider.value = min;
    maxSlider.value = max;

    priceValueDisplay.textContent = `Up to ${max === parseFloat(maxSlider.max) ? "∞" : max}`;

    activeFilters.price = { min, max };
    filterProducts();
  }

  minInput.addEventListener("input", () => {
    let value = parseFloat(minInput.value) || 0;
    if (value > parseFloat(maxInput.value || maxSlider.max)) value = parseFloat(maxInput.value || maxSlider.max);
    minInput.value = value;
    updatePriceFilters();
  });

  maxInput.addEventListener("input", () => {
    let value = parseFloat(maxInput.value) || parseFloat(maxSlider.max);
    if (value < parseFloat(minInput.value || 0)) value = parseFloat(minInput.value || 0);
    maxInput.value = value;
    updatePriceFilters();
  });

  minSlider.addEventListener("input", () => {
    minInput.value = minSlider.value;
    updatePriceFilters();
  });

  maxSlider.addEventListener("input", () => {
    maxInput.value = maxSlider.value;
    updatePriceFilters();
  });

  // Checkbox filters
  const inputs = filterWrapper.querySelectorAll("input[type='checkbox']");
  inputs.forEach(input => {
    input.addEventListener("input", () => {
      const type = input.dataset.filterType;
      const value = input.dataset.filterValue.toLowerCase();

      if (!activeFilters[type]) activeFilters[type] = new Set();

      if (input.checked) activeFilters[type].add(value);
      else activeFilters[type].delete(value);

      filterProducts();
    });
  });

  // Filter products function
  function filterProducts() {
    productCards.forEach(card => {
      let visible = true;

      for (const type in activeFilters) {
        if (!activeFilters[type] || activeFilters[type].size === 0) continue;

        if (type === "price") {
          const price = parseFloat(card.dataset.price) || 0;
          if (price < activeFilters.price.min || price > activeFilters.price.max) {
            visible = false;
            break;
          }
        } else {
          const cardValues = (card.dataset[type] || "").toLowerCase().split(",").map(v => v.trim());
          const matched = [...activeFilters[type]].some(f => cardValues.includes(f));
          if (!matched) {
            visible = false;
            break;
          }
        }
      }

      card.style.display = visible ? "" : "none";
    });
  }

  // Initialize
  updatePriceFilters();
});